<template>
  <div class="payment-rejected">
    <exclamation-circle
      scale="4"
      color="red"
      class="w-full"
    />
    <p
      class="text-3xl bold"
    >
      {{ $t('usaSms.PAYMENT_REJECTED_TITLE') }}
    </p>
    <p
      :key="index"
      class="text-xl mt-8"
    >
      {{ $t('usaSms.PAYMENT_REJECTED') }}
    </p>
    <button
      class="button"
      @click="goBack"
    >
      {{ $t('text.exit') }}
    </button>
  </div>
</template>

<script>
import { ExclamationCircle } from '@/components/icons';

export default {
  name: 'PaymentRejectedUsa',
  components: { ExclamationCircle },
  methods: {
    goBack() {
      this.$router.push({ name: 'SetNumber' });
    }
  }
};
</script>

<style scoped lang="scss">
.payment-rejected {
  padding: 1rem;
  margin-top: 2rem;
  display: grid;
  gap: .5rem;
  text-align: center;
  height: 100%;
  color:black;
}
</style>
